import {
  FETCH_SURVEY_SUCCESS,
  SUBMIT_ANSWER_SUCCESS,
  SUBMIT_ANSWER_PENDING,
  SUBMIT_ANSWER_FAIL,
  REMOVE_ANSWER,
  RESET_ANSWERS,
  RESET_APP,
} from '~/constants/action_types';

// A dictionary of answers referenced by questionId keys.
// `answer` can be of any type.
//
// Example:
// {
//   123: {
//     value: 'my answer',
//     comment: 'my unique comments',
//     isSkipped: false,
//     isSubmitted: true
//   },
//   456: {
//      isSkipped: true
//      isSubmitted: false,
//      error: 'Something went wrong'
//   }
// }
const questionsReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_SURVEY_SUCCESS:
      if (action.isPreview) return action.answers;
      return {
        ...state,
        ...action.answers,
      };
    case SUBMIT_ANSWER_SUCCESS:
      // If questionId already exists, it will be overwritten,
      // otherwise it will be appended.
      return {
        ...state,
        [action.questionId]: {
          questionType: action.questionType,
          value: action.value,
          comment: action.comment,
          isSkipped: action.isSkipped,
          isSubmitted: action.isSubmitted,
        },
      };
    case SUBMIT_ANSWER_PENDING:
      // TODO: indicate that answer submit is in progress?
      return state;
    case SUBMIT_ANSWER_FAIL:
      // Still save the answer details in the local app state, but indicate that
      // the answer wasn't saved to the backend, and store any related error message.
      return {
        ...state,
        [action.questionId]: {
          questionType: action.questionType,
          value: action.value,
          comment: action.comment,
          isSkipped: action.isSkipped,
          isSubmitted: action.isSubmitted,
          error: action.error,
        },
      };
    case REMOVE_ANSWER:
      // If questionId matches, it's skipped in creation of new state.
      return Object.keys(state).reduce((newState, questionId) => {
        if (Number(questionId) === action.questionId) return newState; // skip

        return {
          ...newState,
          [questionId]: state[questionId],
        };
      }, {});
    case RESET_ANSWERS:
    case RESET_APP:
      return {};
    default:
      return state;
  }
};

export default questionsReducer;
